import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { I18nMessages } from "../../../../../../../i18n/i18n";
var Silhouette;
(function (Silhouette) {
    Silhouette["TRIANGLE"] = "TRIANGLE";
    Silhouette["OVAL"] = "OVAL";
    Silhouette["INVERTED_TRIANGLE"] = "INVERTED_TRIANGLE";
    Silhouette["RECTANGLE"] = "RECTANGLE";
    Silhouette["HOURGLASS"] = "HOURGLASS";
    Silhouette["DIAMOND"] = "DIAMOND";
})(Silhouette || (Silhouette = {}));
const SILHOUETTE_GUIDE = {
    [Silhouette.TRIANGLE]: {
        icon: "shape_triangle",
        title: I18nMessages.SILHOUETTE_SILHOUETTE_TRIANGLE_TITLE,
        description: I18nMessages.SILHOUETTE_SILHOUETTE_TRIANGLE_TEXT,
    },
    [Silhouette.OVAL]: {
        icon: "shape_oval",
        title: I18nMessages.SILHOUETTE_SILHOUETTE_OVAL_TITLE,
        description: I18nMessages.SILHOUETTE_SILHOUETTE_OVAL_TEXT,
    },
    [Silhouette.INVERTED_TRIANGLE]: {
        icon: "shape_wedge",
        title: I18nMessages.SILHOUETTE_SILHOUETTE_INVERTED_TRIANGLE_TITLE,
        description: I18nMessages.SILHOUETTE_SILHOUETTE_INVERTED_TRIANGLE_TEXT,
    },
    [Silhouette.RECTANGLE]: {
        icon: "shape_rectangle",
        title: I18nMessages.SILHOUETTE_SILHOUETTE_RECTANGLE_TITLE,
        description: I18nMessages.SILHOUETTE_SILHOUETTE_RECTANGLE_TEXT,
    },
    [Silhouette.HOURGLASS]: {
        icon: "hourglass",
        title: I18nMessages.SILHOUETTE_SILHOUETTE_HOURGLASS_TITLE,
        description: I18nMessages.SILHOUETTE_SILHOUETTE_HOURGLASS_TEXT,
    },
    [Silhouette.DIAMOND]: {
        icon: "shape_diamond",
        title: I18nMessages.SILHOUETTE_SILHOUETTE_DIAMOND_TITLE,
        description: I18nMessages.SILHOUETTE_SILHOUETTE_DIAMOND_TEXT,
    },
};
const MEN_LOOKIERO_SILHOUETTES = [
    Silhouette.TRIANGLE,
    Silhouette.OVAL,
    Silhouette.INVERTED_TRIANGLE,
    Silhouette.RECTANGLE,
];
const ALL_SILHOUETTES = [
    Silhouette.TRIANGLE,
    Silhouette.OVAL,
    Silhouette.INVERTED_TRIANGLE,
    Silhouette.RECTANGLE,
    Silhouette.HOURGLASS,
    Silhouette.DIAMOND,
];
const SILHOUETTES_BY_SEGMENT = {
    [Segment.MEN]: ALL_SILHOUETTES,
    [Segment.WOMEN]: ALL_SILHOUETTES,
};
const SILHOUETTES_BY_TRADENAME_AND_SEGMENT = {
    [Tradename.LOOKIERO]: {
        ...SILHOUETTES_BY_SEGMENT,
        [Segment.MEN]: MEN_LOOKIERO_SILHOUETTES,
    },
    [Tradename.OUTFITTERY]: SILHOUETTES_BY_SEGMENT,
};
const getSilhouetteGuide = ({ segment, tradename, }) => {
    const silhouettes = SILHOUETTES_BY_TRADENAME_AND_SEGMENT[tradename][segment];
    return silhouettes.map((silhouette) => [silhouette, SILHOUETTE_GUIDE[silhouette]]);
};
export { SILHOUETTE_GUIDE, getSilhouetteGuide };
